import { createStore } from 'vuex';

import user from './modules/user';

// Vue.use(Vuex)

const store = createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user: user
  }
});

export default store;